<template>
  <div class="friend">


  </div>
</template>
<script>
  import { Toast } from 'vant';
export default {
  name: 'faceFail',
  data(){
    return{
      userId: '',
      evn: '',
      verifyToken: ''
    }
  },
  computed: {
  },
  methods: {
    // 点击展示个人主页
    initSuccess() {
      console.log(this.$route.query)
      this.userId = this.$route.query.userId
      this.verifyToken = this.$route.query.verifyToken
      this.evn = this.$route.query.evn
      let baseUrl = ''
      if(this.evn == 'test') {
        baseUrl = 'https://sasstest.gclme.com/api/'
      } else if(this.evn == 'pre') {
        baseUrl = 'https://sasspre.gclme.com/api/'
      } else {
        baseUrl = 'https://sass.gclme.com/api/'
      }
      this.$http({
        method : 'post',
        url : `${baseUrl}baiduocr/faceVerify/createVerifyResult`,
        headers:{
          'authorization': this.token
        },
        data:{
          "userId": this.userId,
          "verifyToken": this.verifyToken
        }
      }).then(({ data }) => {
        console.log(data)
        if(data.code == 200) {
          Toast.success('实名认证成功!')
        } else {
          Toast.fail(data.msg)
        }



        var ua = window.navigator.userAgent.toLowerCase();
          //通过正则表达式匹配ua中是否含有MicroMessenger字符串
          if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            Toast.success('3333')
            setTimeout(()=>{
              wx.miniProgram.postMessage({ data: { } })
            },3000)
          }else{
            Toast.success('5555')
            setTimeout(()=>{
              uni.postMessage({
                data: {
                  action: 'success'
                }
              })
            },3000)
          }
      })

    }
  },
  mounted() {
    this.initSuccess()

  }
}

</script>
<style  scoped>

</style>



// WEBPACK FOOTER //
// faceSuccess.vue?7d66f327